import { typeof as _typeof, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { ActionTypes } from '../constants/actionTypes.js';
import { updateResource, createResource, readEndpoint, deleteResource, setHeader } from 'redux-json-api';
import { displayError, clearMessages, displaySuccessMessage, capitalizeMessage } from './messagesActions.js';
import { UnderscoresToTitleCase } from '../utils/StringUtil.js';
import { JsonApiRecordDecorator } from '../json-api/JsonApiRecordDecorator.js';
import { API_READ } from 'redux-json-api/lib/constants';
import { i18n } from '../i18n/translate.js';
import cloneDeep from 'lodash/cloneDeep.js';
var clearApiState = function clearApiState(entity) {
  return {
    type: ActionTypes.CLEAR_API_STATE,
    entity: entity
  };
};
var loadEntities = function loadEntities(entity, endpoint) {
  return {
    type: ActionTypes.ENTITY_WILL_READ,
    entity: entity,
    endpoint: endpoint
  };
};
var readLocal = function readLocal(payload) {
  return {
    type: API_READ,
    payload: payload
  };
};
var setActivePage = function setActivePage(page) {
  return {
    type: ActionTypes.SET_ACTIVE_PAGE,
    activePage: Number.isInteger(page) ? page : page.number
  };
};
var setActiveFilters = function setActiveFilters(filters) {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS,
    filters: filters
  };
};
var setActiveSort = function setActiveSort(sort) {
  return {
    type: ActionTypes.SET_ACTIVE_SORT,
    sort: sort
  };
};
var setActiveSearch = function setActiveSearch(search) {
  return {
    type: ActionTypes.SET_ACTIVE_SEARCH,
    search: search
  };
};
var setActiveState = function setActiveState(state) {
  return {
    type: ActionTypes.SET_ACTIVE_STATE,
    state: state
  };
};
var resetActiveProps = function resetActiveProps() {
  return {
    type: ActionTypes.RESET_ACTIVE_PROPS
  };
};
var setCreatedEntity = function setCreatedEntity(entityId) {
  return {
    type: ActionTypes.LAST_CREATED_ENTITY,
    entityId: entityId
  };
};
var clearLastSelectedEntity = function clearLastSelectedEntity() {
  return {
    type: ActionTypes.CLEAR_LAST_SELECTED_ENTITY
  };
};
var createCurrentEntity = function createCurrentEntity(entityType, defaultValues) {
  return {
    type: ActionTypes.CREATE_CURRENT_ENTITY,
    defaultValues: defaultValues,
    entityType: entityType
  };
};
var setCurrentEntityValues = function setCurrentEntityValues(values) {
  return {
    type: ActionTypes.SET_CURRENT_ENTITY_VALUES,
    values: values
  };
};
var selectEntity = function selectEntity(entityId, type, include, fields) {
  var basePath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var host = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var skipJSONExtension = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var additionalParams = arguments.length > 7 ? arguments[7] : undefined;
  if ([undefined, null].includes(entityId) || _typeof(entityId) !== 'object') {
    return selectEntityFromParams(entityId, type, include, fields, basePath, host, skipJSONExtension, additionalParams);
  } else {
    return selectEntityFromObject(entityId);
  }
};
var selectEntityFromParams = function selectEntityFromParams(entityId, type, include, fields, basePath, host, skipJSONExtension, additionalParams) {
  if (entityId && entityId !== 'add') {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
        var extension, url, additionalParamsString, fieldParams, read;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              extension = skipJSONExtension ? '' : '.json';
              url = "".concat(type, "/").concat(entityId).concat(extension, "?").concat(include ? "include=".concat(include) : '');
              if (additionalParams) {
                additionalParamsString = Object.keys(additionalParams).filter(function (key) {
                  return additionalParams[key] !== null && additionalParams[key] !== undefined;
                }).map(function (param) {
                  return "".concat(param, "=").concat(additionalParams[param]);
                }).join('&');
                url += "".concat(include && additionalParamsString ? '&' : '').concat(additionalParamsString);
              }
              if (fields) {
                fieldParams = Object.keys(fields).filter(function (key) {
                  return fields[key] !== null && fields[key] !== undefined;
                }).map(function (k) {
                  return "fields[".concat(k, "]=").concat(fields[k]);
                }).join('&');
                url += "&".concat(fieldParams);
              }
              dispatch(loadEntities(type, url));
              read = overrideEndpoint(dispatch, getState, readEndpoint(url, getState), basePath, host);
              _context.prev = 6;
              _context.next = 9;
              return read;
            case 9:
              dispatch({
                type: ActionTypes.SELECT_ENTITY,
                entityType: type,
                entityId: entityId
              });
              dispatch({
                type: ActionTypes.CLEAR_LAST_SELECTED_ENTITY
              });
              dispatch({
                type: ActionTypes.LAST_SELECTED_ENTITY,
                entityId: entityId
              });
              dispatch(clearMessages());
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);
              dispatch(displayError(_context.t0));
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 15]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  } else {
    return function (dispatch) {
      dispatch({
        type: ActionTypes.SELECT_ENTITY,
        entityType: type,
        entityId: entityId
      });
    };
  }
};
var selectEntityFromObject = function selectEntityFromObject(_ref2) {
  var id = _ref2.id,
    entity = _ref2.entity,
    includes = _ref2.includes,
    fields = _ref2.fields,
    _ref2$basePath = _ref2.basePath,
    basePath = _ref2$basePath === undefined ? '' : _ref2$basePath,
    _ref2$host = _ref2.host,
    host = _ref2$host === undefined ? '' : _ref2$host,
    _ref2$skipJSONExtensi = _ref2.skipJSONExtension,
    skipJSONExtension = _ref2$skipJSONExtensi === undefined ? false : _ref2$skipJSONExtensi,
    additionalParams = _ref2.additionalParams;
  return selectEntityFromParams(id, entity, includes, fields, basePath, host, skipJSONExtension, additionalParams);
};
function clearAndRead(_x3, _x4, _x5, _x6) {
  return _clearAndRead.apply(this, arguments);
}
function _clearAndRead() {
  _clearAndRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState, entity, readUrl) {
    var read;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          dispatch(loadEntities(entity, readUrl));
          read = readEndpoint(readUrl);
          _context6.prev = 2;
          _context6.next = 5;
          return read(function (params) {
            if (params.type === 'API_READ') {
              dispatch(clearApiState(entity));
            }
            dispatch(params);
          }, getState);
        case 5:
          _context6.next = 10;
          break;
        case 7:
          _context6.prev = 7;
          _context6.t0 = _context6["catch"](2);
          dispatch(displayError(_context6.t0));
        case 10:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[2, 7]]);
  }));
  return _clearAndRead.apply(this, arguments);
}
var readEntityById = function readEntityById(entityId, type, include) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var read;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            read = readEndpoint("".concat(type, "/").concat(entityId, ".json").concat(include ? "?include=".concat(include) : ''), getState);
            _context2.prev = 1;
            _context2.next = 4;
            return read(dispatch, getState);
          case 4:
            _context2.next = 9;
            break;
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](1);
            dispatch(displayError(_context2.t0));
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 6]]);
    }));
    return function (_x7, _x8) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var overrideEndpoint = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState, action, basePath, host) {
    var endpointOverride, getStateOverride;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          endpointOverride = {};
          if (basePath) {
            endpointOverride.path = basePath;
          }
          if (host) {
            endpointOverride.host = host;
          }
          getStateOverride = function getStateOverride() {
            var state = cloneDeep(getState());
            state.api.endpoint = _objectSpread2(_objectSpread2({}, state.api.endpoint), endpointOverride);
            return state;
          };
          _context3.next = 6;
          return action(dispatch, getStateOverride);
        case 6:
          return _context3.abrupt("return", _context3.sent);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function overrideEndpoint(_x9, _x10, _x11, _x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();
function wrapAction(_x14, _x15, _x16, _x17, _x18, _x19) {
  return _wrapAction.apply(this, arguments);
}
function _wrapAction() {
  _wrapAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState, action, syncIndexing, basePath, host) {
    var result;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          syncIndexing = syncIndexing !== false;
          if (syncIndexing) {
            dispatch(setHeader({
              'X-HTTP-SEARCH-INDEX-METHOD': 'synchronous'
            }));
          }
          _context7.next = 4;
          return overrideEndpoint(dispatch, getState, action, basePath, host);
        case 4:
          result = _context7.sent;
          if (syncIndexing) {
            dispatch(setHeader({
              'X-HTTP-SEARCH-INDEX-METHOD': 'default'
            }));
          }
          return _context7.abrupt("return", result);
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _wrapAction.apply(this, arguments);
}
function dispatchAction(actionApi, entity, afterSave, successMessage, defaultMessage, rethrow, syncIndexing, basePath, host) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var unwrappedEntity, action, entityType, resultEntity;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            unwrappedEntity = entity !== null && entity !== undefined && entity.unwrap ? entity.unwrap() : entity;
            action = actionApi(unwrappedEntity);
            entityType = capitalizeMessage(unwrappedEntity.type);
            _context4.prev = 3;
            _context4.next = 6;
            return wrapAction(dispatch, getState, action, syncIndexing, basePath, host);
          case 6:
            resultEntity = _context4.sent;
            dispatch(clearMessages());
            if (typeof afterSave === 'function') {
              afterSave(dispatch, getState, resultEntity);
            }
            if (successMessage !== false) {
              dispatch(displaySuccessMessage(successMessage || "".concat(UnderscoresToTitleCase(entityType), " ").concat(defaultMessage)));
            }
            return _context4.abrupt("return", resultEntity);
          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](3);
            dispatch(displayError(_context4.t0));
            if (!rethrow) {
              _context4.next = 18;
              break;
            }
            throw _context4.t0;
          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 13]]);
    }));
    return function (_x20, _x21) {
      return _ref5.apply(this, arguments);
    };
  }();
}
var updateEntity = function updateEntity(entity, afterSave, successMessage, rethrow, syncIndexing, basePath, host) {
  if (entity instanceof JsonApiRecordDecorator) {
    return updateEntityFromParams(entity, afterSave, successMessage, rethrow, syncIndexing, basePath, host);
  } else {
    return updateEntityFromObject(entity);
  }
};
var updateEntityFromParams = function updateEntityFromParams(entity, afterSave, successMessage, rethrow, syncIndexing, basePath, host) {
  return dispatchAction(updateResource, entity, afterSave, successMessage, i18n.t('updated successfully!'), rethrow, syncIndexing, basePath, host);
};
var updateEntityFromObject = function updateEntityFromObject(_ref6) {
  var member = _ref6.member,
    afterSave = _ref6.afterSave,
    successMessage = _ref6.successMessage,
    rethrow = _ref6.rethrow,
    syncIndexing = _ref6.syncIndexing,
    basePath = _ref6.basePath,
    host = _ref6.host;
  return updateEntityFromParams(member, afterSave, successMessage, rethrow, syncIndexing, basePath, host);
};
var createEntity = function createEntity(entity, afterSave, successMessage, rethrow, syncIndexing, basePath, host) {
  if (entity instanceof JsonApiRecordDecorator) {
    return createEntityFromParams(entity, afterSave, successMessage, rethrow, syncIndexing, basePath, host);
  } else {
    return createEntityFromObject(entity);
  }
};
var createEntityFromParams = function createEntityFromParams(entity, afterSave, successMessage, rethrow, syncIndexing, basePath, host) {
  return dispatchAction(createResource, entity, afterSave, successMessage, i18n.t('created successfully!'), rethrow, syncIndexing, basePath, host);
};
var createEntityFromObject = function createEntityFromObject(_ref7) {
  var member = _ref7.member,
    afterSave = _ref7.afterSave,
    successMessage = _ref7.successMessage,
    rethrow = _ref7.rethrow,
    syncIndexing = _ref7.syncIndexing,
    basePath = _ref7.basePath,
    host = _ref7.host;
  return createEntityFromParams(member, afterSave, successMessage, rethrow, syncIndexing, basePath, host);
};
var deleteEntity = function deleteEntity(val, entity, successMessage, rethrow, syncIndexing, basePath, host) {
  if (entity) {
    return deleteEntityFromParams(val, entity, successMessage, rethrow, syncIndexing, basePath, host);
  } else {
    return deleteEntityFromObject(val);
  }
};
var deleteEntityFromParams = function deleteEntityFromParams(val, entity, successMessage, rethrow, syncIndexing, basePath, host) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var del, entityType;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (val.unwrap) {
              val = val.unwrap();
            }
            del = deleteResource(val, entity);
            entityType = capitalizeMessage(entity);
            _context5.prev = 3;
            _context5.next = 6;
            return wrapAction(dispatch, getState, del, syncIndexing, basePath, host);
          case 6:
            dispatch(clearMessages());
            dispatch({
              type: ActionTypes.DELETE_ENTITY,
              entityType: entity,
              val: val
            });
            if (successMessage !== false) {
              dispatch(displaySuccessMessage(successMessage || i18n.t('%s deleted successfully!', {
                postProcess: 'sprintf',
                sprintf: [UnderscoresToTitleCase(entityType)]
              })));
            }
            _context5.next = 16;
            break;
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](3);
            dispatch(displayError(_context5.t0));
            if (!rethrow) {
              _context5.next = 16;
              break;
            }
            throw _context5.t0;
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[3, 11]]);
    }));
    return function (_x22, _x23) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var deleteEntityFromObject = function deleteEntityFromObject(_ref9) {
  var member = _ref9.member,
    entity = _ref9.entity,
    successMessage = _ref9.successMessage,
    rethrow = _ref9.rethrow,
    syncIndexing = _ref9.syncIndexing,
    basePath = _ref9.basePath,
    host = _ref9.host;
  return deleteEntityFromParams(member, entity, successMessage, rethrow, syncIndexing, basePath, host);
};
export { clearAndRead, clearApiState, clearLastSelectedEntity, createCurrentEntity, createEntity, deleteEntity, loadEntities, overrideEndpoint, readEntityById, readLocal, resetActiveProps, selectEntity, setActiveFilters, setActivePage, setActiveSearch, setActiveSort, setActiveState, setCreatedEntity, setCurrentEntityValues, updateEntity };